'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

const LogMessageComponent = ({ log, logType }) => {
  if (!log) {
    return (
      <Panel>
        <Panel.Heading>
          <Panel.Title>
            {'No ' + logType}
          </Panel.Title>
        </Panel.Heading>
      </Panel>
    );
  }

  return (
    <Panel bsStyle="warning" collapsible="true">
      <Panel.Heading>
        <Panel.Title toggle>
          {logType}
        </Panel.Title>
      </Panel.Heading>
      <Panel.Collapse>
        <pre>
          {log}
        </pre>
      </Panel.Collapse>
    </Panel>
  );
};

LogMessageComponent.propTypes = {
  log: PropTypes.string,
  logType: PropTypes.string
};

export default LogMessageComponent;



// WEBPACK FOOTER //
// src/Components/LogMessageComponent.jsx